import React, { useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import { InputAdornment } from '@material-ui/core'
import YumField from '../../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as DailyGoalInactiveIcon } from '../../../../../assets/v3/icons/daily-goal-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface DailyGoalFieldProps {
  control: Control<FormData>
  fieldPrefix: string
  validationRules: {
    min?: number
    max?: number
    required?: boolean
  }
  endAdornment: string
}

/**
 * Daily goal input field.
 * Allows users to set a daily goal amount with appropriate unit display.
 */
export default function DailyGoalField({ control, fieldPrefix, validationRules, endAdornment }: DailyGoalFieldProps) {
  // Memoize InputProps to prevent input from losing focus on re-render
  const inputProps = useMemo(
    () => ({
      endAdornment: (
        <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
          {endAdornment}
        </InputAdornment>
      ),
      // style: {
      //   background: 'white',
      // },
    }),
    [endAdornment],
  )

  return (
    <Controller
      name={getFieldName('dailyGoal', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          <YumField
            label={t`Daily target`}
            type="number"
            inputProps={{ inputMode: 'numeric' }}
            onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
            error={!!error}
            InputProps={inputProps}
            startIcon={DailyGoalInactiveIcon}
            style={{
              marginBottom: 0,
              // marginTop: 12,
            }}
            {...otherField}
            value={otherField.value ?? ''}
          />
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
